module.exports = __webpack_public_path__ + "img/27.e2f3c7bd.png";